import React, { useState, useEffect } from "react";
import "./rps.css";
import task from "../Task";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import { userGameRewards } from "../../../apis/user";
import { logPageView } from "../../../components/analytics";

// Result component integrated directly
const Result = ({ user, computer, result }) => (
  <div className= { result ? "rps_result-container-result" : "rps_result-container"}>
    <p className="rps_choice">YOUR CHOICE: <strong className="rps_choice-text">{user}</strong></p>
    <p className="rps_choice">THEMEMETV'S CHOICE: <strong className="rps_choice-text">{computer}</strong></p>
    <h2 className="rps_result-text">{result}</h2>
  </div>
);

function Rockpaperscissors() {
  const { updateUserInfo, userDetails } = useUserInfo();
  const playClick = useAudio();

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const [userChoice, setUserChoice] = useState("");
  const [computerChoice, setComputerChoice] = useState("");
  const [result, setResult] = useState("");
  const [userScore, setUserScore] = useState(0);
  const [compScore, setCompScore] = useState(0);
  const [roundsLeft, setRoundsLeft] = useState(5);
  const [gameOver, setGameOver] = useState(false);

  const rockImg = "https://d1ccopf5cw1hft.cloudfront.net/s3data/rock.png";
  const paperImg = "https://d1ccopf5cw1hft.cloudfront.net/s3data/paper.png";
  const scissorsImg = "https://d1ccopf5cw1hft.cloudfront.net/s3data/scissors.png";

  const choices = ["rock", "paper", "scissors"];
  
  const images = {
    rock: rockImg,
    paper: paperImg,
    scissors: scissorsImg,
  };

  useEffect(() => {
    logPageView("Rock Paper Scissors", "Rock Paper Scissors");
  }, []);

  const determineResult = (user, comp) => {
    if (user === comp) {
      setResult("IT'S A DRAW!");
    } else if (
      (user === "rock" && comp === "scissors") ||
      (user === "scissors" && comp === "paper") ||
      (user === "paper" && comp === "rock")
    ) {
      setResult("YOU WIN!");
      setUserScore((score) => score + 10);
    } else {
      setResult("YOU LOSE!");
      setUserScore((score) => Math.max(0, score - 10));
    }
  };

  const handleApiResponse = async (points) => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "rock paper scissors",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        setGameOver(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  const play = (choice) => {
    if (roundsLeft <= 0) return;

    const comp = choices[Math.floor(Math.random() * 3)];
    setUserChoice(choice);
    setComputerChoice(comp);
    
    // Calculate result first
    let currentResult;
    if (choice === comp) {
      currentResult = "IT'S A DRAW!";
    } else if (
      (choice === "rock" && comp === "scissors") ||
      (choice === "scissors" && comp === "paper") ||
      (choice === "paper" && comp === "rock")
    ) {
      currentResult = "YOU WIN!";
    } else {
      currentResult = "YOU LOSE!";
    }
    
    setResult(currentResult);
    determineResult(choice, comp);
    
    const newRoundsLeft = roundsLeft - 1;
    setRoundsLeft(newRoundsLeft);

    // Check after the round is complete
    if (newRoundsLeft === 0) {
      const finalScore = userScore + (currentResult === "YOU WIN!" ? 10 : (currentResult === "YOU LOSE!" ? -10 : 0));
      if (finalScore > 0) {
        handleApiResponse(finalScore);
      } else {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: true,
        }));
        setTimeout(() => {
          updateUserInfo((prev) => ({
            ...prev,
            isLoading: false,
          }));
          setGameOver(true);
        }, 1000);
      }
    }
  };

  const resetGame = () => {
    setUserChoice("");
    setComputerChoice("");
    setResult("");
    setUserScore(0);
    setCompScore(0);
    setRoundsLeft(5);
    setGameOver(false);
  };

  return (
    <div className="rps_game-container">
      {/* <img
        onClick={toogleMenu}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/backicon.svg"
        className="rps_back-btn"
        style={{ cursor: "pointer" }}
      /> */}
      <img
        onClick={toogleMenu}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="rps_back-btn"
        style={{ cursor: "pointer" }}
      />
      <h1 className="rps_title">ROCK PAPER SCISSORS</h1>
      <p className="rps_rounds">ROUNDS LEFT: {roundsLeft}</p>
      <div className="rps_scoreboard">
        <span className="rps_score">YOU: {userScore}</span>
        <span className="rps_score">THEMEMETV: {compScore}</span>
      </div>

      <div className="rps_play-area">
        <div className="rps_user-side">
          {choices.map((choice) => (
            <button
              key={choice}
              onClick={() => play(choice)}
              disabled={gameOver}
              className="rps_choice-btn"
            >
              <img src={images[choice]} alt={choice} className="rps_choice-img" />
              <span className="rps_choice-label">{choice}</span>
            </button>
          ))}
        </div>

        <div className="rps_choices-display">
          {userChoice && (
            <div className={`rps_choice-display ${
              result === "YOU WIN!" ? "win" : 
              result === "YOU LOSE!" ? "lose" : 
              result === "IT'S A DRAW!" ? "draw" : ""
            }`}>
              <p className="rps_choice-text">You chose:</p>
              <img
                src={images[userChoice]}
                alt={userChoice}
                className="rps_choice-display-img"
              />
            </div>
          )}
          {computerChoice && (
            <div className={`rps_choice-display ${
              result === "YOU LOSE!" ? "win" : 
              result === "YOU WIN!" ? "lose" : 
              result === "IT'S A DRAW!" ? "draw" : ""
            }`}>
              <p className="rps_choice-text">THEMEMETV chose:</p>
              <img
                src={images[computerChoice]}
                alt={computerChoice}
                className="rps_choice-display-img"
              />
            </div>
          )}
        </div>
      </div>

      <Result user={userChoice} computer={computerChoice} result={result} />

      {userDetails.userDetails?.isLoading && (
        <div className="rps_loader-overlay">
          <div className="rps_loader"></div>
        </div>
      )}

      {gameOver && (
        <div className="rps_overlay">
          <div className="rps_full-popup">
            <div className="rps_popup-content">
              <h2 className="rps_epic">GAME OVER!</h2>
              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                className="rps_cancel-img"
                onClick={resetGame}
              />
              <div className="rps_popup-row">
                <div className="rps_popup-col">
                  <div className="rps_epic-div">
                    <p className="rps_pointsLabel">TOKENS EARNED</p>
                    <div className="rps_pointsValue">
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        alt="logo"
                      />
                      <p className="rps_pointsNumber">{userScore}</p>
                    </div>
                  </div>
                  <p className="rps_bottom-text">
                    ROCK, PAPER, SCISSORS <br />WIN. EARN. REPEAT.
                  </p>
                  <button onClick={resetGame} className="rps_play-again-btn">
                    PLAY AGAIN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Rockpaperscissors;
